import type { ReactNode } from "react";

import type { PermissionCode } from "@/core/authz/permissions";
import { ForbiddenPage } from "@/shared/components/ForbiddenPage";
import { useAuth } from "@/shared/contexts/AuthContext";

/**
 * Route guard for the `view` grant, layered inside RequireAuth: by the time
 * this renders the user is known, so a missing grant is a 403 rather than a
 * bounce to /login.
 *
 * The screen renders in place instead of redirecting so the address bar
 * keeps the URL the operator asked for — they can hand the link to someone
 * who does hold the grant.
 */
export function RequirePermission({
  permission,
  children,
}: {
  permission: PermissionCode;
  children: ReactNode;
}) {
  const { hasPermission } = useAuth();

  if (!hasPermission(permission)) {
    return <ForbiddenPage />;
  }

  return <>{children}</>;
}
